module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"checkAvailability":"Tarkista saatavuus"},"en":{"checkAvailability":"Check Availability"}}')
  delete Component.options._Ctor
}
